<script lang="ts">
    export let logo = null;
    export let name;
    export let info = null;

    function expand(e) {

        const legend = e.currentTarget
        legend.classList.toggle('fieldset-legend--active');

        const panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = (panel.scrollHeight + 100) + "px";
        }
    }
</script>

<fieldset class="box pb-6">
    <legend on:click={expand} class="label fieldset-legend">
        <div class="fieldset-legend-container is-flex">
            <div class="fieldset-logo-container is-flex">
                {#if logo}
                    <img class="fieldset-logo mr-3" src="assets/img/{logo}" alt="icone">
                {/if}
                <p class="is-flex is-align-items-center">{name}</p>
            </div>
            <div class="fieldset-icon-container is-flex is-align-items-center is-justify-content-end">
                <p class="fieldset-icon"></p>
            </div>
        </div>
    </legend>
    <div class="fieldset-container">
        {#if info}
            <slot name="info">{@html info}</slot>
        {/if}
        <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
            <div class=" column is-12 is-6-desktop">
                <slot name="slot1"></slot>
            </div>
            <div class=" column is-12 is-6-desktop">
                <slot name="slot2"></slot>
            </div>
        </div>
        <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
            <div class="column is-12 is-6-desktop">
                <slot name="slot3"></slot>
            </div>
            <div class="column is-12 is-6-desktop">
                <slot name="slot4"></slot>
            </div>
        </div>
        <slot name="additional-fields"></slot>
    </div>
</fieldset>
